<template>
    <div class="flex w-full flex-col cursor-default">
        <div
            :class="[
                'background blue bg-center bg-no-repeat bg-cover w-full pt-6 md:px-6 md:pb-6 md:mb-6 md:rounded-lg md:shadow',
            ]"
            :style="bannerStyle"
        >
            <div class="relative flex flex-col-reverse items-start w-full md:flex-col">
                <div class="flex flex-col w-full">
                    <div class="flex flex-col md:flex-col">
                        <div class="max-md:container">
                            <h1
                                :class="[
                                    'md:pr-24 mb-4 md:mb-2',
                                    'font-display-4 md:font-display-3 leading-10 md:text-8xl md:leading-15 line-clamp-3 md:line-clamp-2',
                                    hasBackgroundImage ? ' text-white' : ' text-black',
                                ]"
                                style="word-break: break-word !important"
                                v-text="t('info.title', { uniName: university.name })"
                            ></h1>
                            <div
                                :class="[
                                    'flex flex-col items-start w-full md:flex-row md:mb-6',
                                    hasBackgroundImage ? ' text-white' : ' text-black',
                                ]"
                            >
                                <p class="flex flex-row items-center mb-2 md:mb-0 md:pr-4">
                                    <i class="mr-2 icon icon-people"></i
                                    ><span v-text="university.total_students"></span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="info bg-white py-6 max-md:container shadow md:px-6 md:pb-5 md:rounded-lg">
            <h3 class="font-subtitle-2">{{ t('info.headline', { uniName: university.name }) }}</h3>
            <div class="mt-2">
                <CollapsibleText
                    :content="universityInfo"
                    :max-lines="3"
                    show-more-appearance="text-slate-400 font-medium leading-6 md:text-lg md:leading-8"
                    content-appearance="uni-info text-slate-600 leading-6 break-normal md:text-lg md:leading-8"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CollapsibleText from '@components/CollapsibleText';
import { useTranslation } from 'i18next-vue';

export default {
    name: 'UniversityShowHeader',
    components: {
        CollapsibleText,
    },
    props: {
        university: {
            type: Object,
            required: true,
        },
    },
    setup() {
        const { t } = useTranslation('university');
        return { t };
    },
    data() {
        return {
            infoIsCollapsed: true,
        };
    },
    computed: {
        ...mapGetters({
            screenSize: 'ui/screenSize',
            locale: 'ui/getLocale',
        }),
        hasBackgroundImage() {
            return this.university && this.university.image && this.university.background_image !== undefined;
        },
        bannerStyle() {
            return this.hasBackgroundImage
                ? {
                      'background-image': `url( ${this.university.background_image})`,
                  }
                : {};
        },
        infoText() {
            return this.t('university:info.info_part_1');
        },
        universityInfo() {
            return this.t('university:info.info_description', { uniName: this.university.name });
        },
    },
};
</script>

<style lang="scss" scoped>
.background {
    &.blue {
        background-image: url(/images/backgrounds/background-blue-shape-2.svg);
    }
}
.info {
    min-height: 202px;
}
</style>
